import { render } from "./generic-error.vue?vue&type=template&id=b840b182&ts=true"
import script from "./generic-error.vue?vue&type=script&lang=ts"
export * from "./generic-error.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__